module.exports = __webpack_public_path__ + "img/office--chair.2e6d5947.svg";